<template>
  <div class="statistics">
    <div class="stat">
      <span class="stat-label">Depressed level: </span>
      <span class="stat-stat">{{ existingEntry.data.downLevel }}</span>
    </div>
    <div class="stat">
      <span class="stat-label">Anxiety level: </span>
      <span class="stat-stat">{{ existingEntry.data.anxietyLevel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stats",
  props: ["existingEntry"]
}
</script>

